export const getCalcStyleInt = (expression: string) => {
  const dummy = document.createElement("div");
  dummy.style.display = "none";
  dummy.style.setProperty("z-index", expression);
  document.body.appendChild(dummy);

  const value = Number.parseFloat(
    getComputedStyle(dummy).getPropertyValue("z-index")
  );
  dummy.remove();

  return value;
};

export const getCalcStylePx = (expression: string) => {
  const dummy = document.createElement("div");
  dummy.style.display = "none";
  dummy.style.setProperty("width", expression);
  document.body.appendChild(dummy);

  const value = Number.parseFloat(
    getComputedStyle(dummy).getPropertyValue("width").replace(/px$/, "")
  );
  dummy.remove();

  return value;
};
